<script setup>
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  headerTitle: {
    type: String,
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['click', 'close']);

const handleButtonClick = () => {
  emit('click');
};
</script>

<template>
  <section class="flex flex-col w-full h-full overflow-hidden bg-n-background">
    <header class="sticky top-0 z-10 px-4 sm:px-6 lg:px-0">
      <div class="w-full max-w-[60rem] mx-auto">
        <div
          class="flex flex-row flex-wrap items-center justify-between w-full gap-2 py-3 sm:h-20"
        >
          <span
            class="text-xl font-medium text-n-slate-12 truncate flex-1 min-w-[200px]"
          >
            {{ headerTitle }}
          </span>
          <div class="flex items-center gap-2 flex-wrap ml-auto">
            <slot name="left-action" />
            <div
              v-on-clickaway="() => emit('close')"
              class="relative group/campaign-button"
            >
              <Button
                :aria-label="buttonLabel"
                icon="i-lucide-plus"
                size="sm"
                class="group-hover/campaign-button:brightness-110"
                @click="handleButtonClick"
              >
                <span class="hidden sm:inline">{{ buttonLabel }}</span>
              </Button>
              <slot name="action" />
            </div>
          </div>
        </div>
      </div>
    </header>
    <main class="flex-1 px-4 sm:px-6 overflow-y-auto lg:px-0">
      <div class="w-full max-w-[60rem] mx-auto py-4">
        <slot name="default" />
      </div>
    </main>
  </section>
</template>
